import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.vendor/picker/term-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
import VendorParser from "emun.vendor/parser/vendor-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class TermPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setTerms();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `term-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setTerms();
	}
	clearAll() {
		this.selected = {};
		this.setTerms();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(term) {
		return !!this.selected[term.id];
	}

	setTerms() {
		this.terms = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { terms: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(term) {
		const $ctrl = this;
		console.log("toggle", term.id, $ctrl.selected, term);

		if ($ctrl.single) {
			$ctrl.$close(term);
		} else if (term.id in $ctrl.selected) {
			delete $ctrl.selected[term.id];
			$ctrl.onTermUnSelected &&
				$ctrl.onTermUnSelected({ $term: term, ...$ctrl });
		} else {
			$ctrl.selected[term.id] = true;
			$ctrl.onTermSelected &&
				$ctrl.onTermSelected({ $term: term, ...$ctrl });
		}
		this.setTerms();
	}
	select(term) {
		const $ctrl = this;
		$ctrl.$close([term]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	// parseVendors() {
	// 	const $ctrl = this;
	// 	VendorParser({}).then(vendorIds => {
	// 		$ctrl.selected = {};
	// 		vendorIds.forEach(vendorId => {
	// 			$ctrl.toggle({ id: vendorId });
	// 		});
	// 		$ctrl.viewSelections = true;
	// 		$ctrl.viewSelectionsChanged();
	// 	});
	// }

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryPaymentTerms.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			// sortOptions: {
			// 	"GroupName": "Name",
			// 	"-GroupName": "Name"
			// },
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			//orderBy: "GroupName",
			autoLoad: true,
			append: false
		};
	}
}


